import React, { useEffect, useState } from 'react';
import { getSiteNotice } from '../api/siteNotice';
import './AvisSection.css';

const lines = (text) => (text || '').split('\n').filter((l) => l.trim() !== '');

const AvisSection = () => {
  const [n, setN] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getSiteNotice().then((d) => { if (!cancelled) setN(d); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!n) return null;

  return (
    <div className="avis-section">
      <h1 className="avis-title">Avis</h1>
      {n.subtitle && <p className="avis-subtitle">{n.subtitle}</p>}

      <div className="avis-addresses">
        {[[n.center1_name, n.center1_lines], [n.center2_name, n.center2_lines]].map(
          ([name, body], i) => (
            <div key={i} className="address-col">
              {name && <p><strong>{name}</strong></p>}
              {lines(body).map((l, j) => <p key={j}>{l}</p>)}
            </div>
          )
        )}
      </div>

      {lines(n.extra_lines).length > 0 && (
        <div className="avis-extra">
          {lines(n.extra_lines).map((l, i) => <p key={i}>{l}</p>)}
        </div>
      )}

      {n.announcement_enabled && n.announcement && (
        <p className="avis-announcement">{n.announcement}</p>
      )}

      {n.footer && <p className="avis-footer">{n.footer}</p>}
    </div>
  );
};

export default AvisSection;
